<div style="padding: 24px;">
  <div class="calendar-toolbar">
    <ng-container *ngIf="googleCal.accessToken$ | async as token; else connectTpl">
      <button nz-button nzDanger class="btn-disconnect" type="button" (click)="disconnectGoogle()">
        Desconectar Google
      </button>
    </ng-container>
    <ng-template #connectTpl>
      <button
        nz-button
        class="btn-add"
        type="button"
        [nzLoading]="signingIn"
        (click)="connectGoogle()"
      >
        Conectar con Google
      </button>
    </ng-template>
  </div>

  <nz-spin [nzSpinning]="calendarLoading">
    <div class="calendar-wrap">
      <full-calendar [options]="calendarOptions"></full-calendar>
    </div>
  </nz-spin>
</div>

<app-prospect-modal
  [(visible)]="prospectModalVisible"
  [prospect]="null"
  [prefillDate]="prospectPrefillDate"
  (saved)="onProspectSaved()"
/>

<nz-modal
  [(nzVisible)]="infoModalVisible"
  [nzTitle]="infoTitle"
  [nzFooter]="infoFooter"
  (nzOnCancel)="infoModalVisible = false"
  [nzWidth]="420"
>
  <ng-template #infoTitle>
    <app-modal-title icon="calendar" [title]="infoEvent?.title ?? 'Evento'" />
  </ng-template>

  <div *nzModalContent class="event-info-body">
    @if (infoEvent) {
      @if (infoEvent.isGoogle) {
        <!-- Evento de Google -->
        <div class="event-info-badge" style="background: #f3e8ff; border-color: #d8b4fe;">
          <span class="event-info-dot" style="background: #722ed1;"></span>
          <span class="event-info-badge-text" style="color: #722ed1;">Google Calendar</span>
        </div>

        <div class="event-info-row">
          <span nz-icon nzType="clock-circle" nzTheme="outline" class="event-info-icon"></span>
          <div class="event-info-dates">
            <span>{{ infoEvent.start | date:'EEEE d MMM y, HH:mm' }}</span>
            @if (infoEvent.end) {
              <span class="event-info-separator">—</span>
              <span>{{ infoEvent.end | date:'HH:mm' }}</span>
            }
          </div>
        </div>

        @if (infoEvent.description) {
          <div class="event-info-desc">
            <span nz-icon nzType="message" nzTheme="outline" class="event-info-icon"></span>
            <p>{{ infoEvent.description }}</p>
          </div>
        }

        @if (infoEvent.htmlLink) {
          <a [href]="infoEvent.htmlLink" target="_blank" rel="noopener" class="event-info-link">
            <span nz-icon nzType="export" nzTheme="outline"></span>
            Ver en Google Calendar
          </a>
        }
      } @else {
        <!-- Evento interno SINAY -->
        <div class="event-info-header">
          @if (infoEvent.stageName) {
            <div class="event-info-badge" [style.background]="'color-mix(in srgb, ' + (infoEvent.stageColor ?? '#8c8c8c') + ' 10%, transparent)'" [style.border-color]="'color-mix(in srgb, ' + (infoEvent.stageColor ?? '#8c8c8c') + ' 25%, transparent)'">
              <span class="event-info-dot" [style.background]="infoEvent.stageColor ?? '#8c8c8c'"></span>
              <span class="event-info-badge-text" [style.color]="infoEvent.stageColor ?? '#8c8c8c'">{{ infoEvent.stageName }}</span>
            </div>
          }
          @if (infoActions.length > 0) {
            <app-button-actions
              [row]="selectedAgenda"
              [actions]="infoActions"
              (action)="onInfoAction($event)"
            />
          }
        </div>

        @if (infoEvent.prospectName) {
          <div class="event-info-row">
            <span nz-icon nzType="user" nzTheme="outline" class="event-info-icon"></span>
            <span>{{ infoEvent.prospectName }}</span>
          </div>
        }

        <div class="event-info-row">
          <span nz-icon nzType="clock-circle" nzTheme="outline" class="event-info-icon"></span>
          <div class="event-info-dates">
            <span>{{ infoEvent.start | date:'EEEE d MMM y, HH:mm' }}</span>
            @if (infoEvent.end) {
              <span class="event-info-separator">—</span>
              <span>{{ infoEvent.end | date:'HH:mm' }}</span>
            }
          </div>
        </div>

        <div class="event-info-row">
          <span nz-icon nzType="calendar" nzTheme="outline" class="event-info-icon"></span>
          <span class="event-info-source">SINAY</span>
        </div>

        @if (infoEvent.description) {
          <div class="event-info-desc">
            <span nz-icon nzType="message" nzTheme="outline" class="event-info-icon"></span>
            <p>{{ infoEvent.description }}</p>
          </div>
        }

        @if (infoEvent.htmlLink) {
          <a [href]="infoEvent.htmlLink" target="_blank" rel="noopener" class="event-info-link">
            <span nz-icon nzType="export" nzTheme="outline"></span>
            Ver en Google Calendar
          </a>
        }

      }
    }
  </div>

  <ng-template #infoFooter>
    <button nz-button class="sinay-outline-reset" (click)="infoModalVisible = false">Cerrar</button>
  </ng-template>
</nz-modal>

<app-reschedule-modal
  [(visible)]="rescheduleModalVisible"
  [mode]="scheduleMode"
  [prospect]="selectedAgenda ? { sprospecto: selectedAgenda.prospectname } : null"
  [googleEventId]="selectedAgenda?.googleEventId ?? null"
  (scheduled)="onScheduled($event)"
/>
